//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Portal } from 'portal-vue'
import { disablePageScroll, enablePageScroll } from 'scroll-lock';
export default {
  components: {
    Portal
  },
  // mounted() {
  //   disablePageScroll();
  // },
  // beforeDestroy() {
  //   enablePageScroll();
  // },
  methods: {
    close (...args) {
      /**
       * Клик на закрытии (крестик или подложка)
       */
      this.$emit('close', ...args)
    }
  }
}
